import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lg:grid lg:grid-cols-3 gap-[25px]" }
const _hoisted_2 = { class: "lg:col-span-1" }
const _hoisted_3 = { class: "lg:col-span-2" }
const _hoisted_4 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_5 = { class: "trezo-card-header mb-[15px] md:mb-[20px] flex items-center justify-between" }
const _hoisted_6 = { class: "trezo-card-subtitle flex items-center" }
const _hoisted_7 = { class: "trezo-card-dropdown relative ltr:ml-[2px] rtl:mr-[2px] ltr:mr-[15px] rtl:ml-[15px] ltr:md:mr-[25px] rtl:md:ml-[25px]" }
const _hoisted_8 = { class: "trezo-card-dropdown relative" }
const _hoisted_9 = { class: "trezo-card-content relative" }
const _hoisted_10 = {
  class: "trezo-tabs",
  id: "trezo-tabs"
}
const _hoisted_11 = { class: "inbox-navs" }
const _hoisted_12 = { class: "nav-item inline-block ltr:mr-[35px] rtl:ml-[35px] ltr:last:mr-0 rtl:last:ml-0" }
const _hoisted_13 = { class: "nav-item inline-block ltr:mr-[35px] rtl:ml-[35px] ltr:last:mr-0 rtl:last:ml-0" }
const _hoisted_14 = { class: "tab-content" }
const _hoisted_15 = { class: "tab-pane" }
const _hoisted_16 = { class: "table-responsive overflow-x-auto" }
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = { class: "text-black dark:text-white" }
const _hoisted_19 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_20 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_21 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_22 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_23 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_24 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_25 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_26 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_27 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_28 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_29 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_30 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_31 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_32 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_33 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_34 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_35 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_36 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_37 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_38 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_39 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_40 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_41 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_42 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_43 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_44 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_45 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_46 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_47 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_48 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_49 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_50 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_51 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_52 = { class: "tab-pane" }
const _hoisted_53 = { class: "table-responsive overflow-x-auto" }
const _hoisted_54 = { class: "w-full" }
const _hoisted_55 = { class: "text-black dark:text-white" }
const _hoisted_56 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_57 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_58 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_59 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_60 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_61 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_62 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_63 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_64 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_65 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_66 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_67 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_68 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_69 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_70 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_71 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_72 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_73 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_74 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_75 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_76 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_77 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_78 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_79 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_80 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_81 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_82 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_83 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_84 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_85 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_86 = { class: "font-medium text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_87 = { class: "text-black dark:text-white relative ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_88 = { class: "relative ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmailSidebar = _resolveComponent("EmailSidebar")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_EmailSidebar)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "form-check relative top-[1px]" }, [
              _createElementVNode("input", {
                type: "checkbox",
                class: "cursor-pointer"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass({
                  'trezo-card-dropdown-btn inline-block transition-all text-[25px] leading-none hover:text-primary-500': true,
                  active: _ctx.isActive,
                }),
                id: "dropdownToggle",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-[18px]" }, " arrow_drop_down ", -1)
              ]), 2),
              _cache[5] || (_cache[5] = _createStaticVNode("<ul class=\"trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[10000] dark:bg-dark dark:shadow-none\"><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> All </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> None </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> Read </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> Unread </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> Starred </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> Unstarred </button></li></ul>", 1))
            ]),
            _cache[9] || (_cache[9] = _createStaticVNode("<button type=\"button\" class=\"inline-block transition-all leading-none hover:text-primary-500 ltr:mr-[10px] rtl:ml-[10px]\"><i class=\"material-symbols-outlined !text-lg\"> archive </i></button><button type=\"button\" class=\"inline-block transition-all leading-none hover:text-primary-500 ltr:mr-[10px] rtl:ml-[10px]\"><i class=\"material-symbols-outlined !text-lg\"> help_clinic </i></button><button type=\"button\" class=\"inline-block transition-all leading-none hover:text-primary-500 ltr:mr-[10px] rtl:ml-[10px]\"><i class=\"material-symbols-outlined !text-lg\"> delete </i></button>", 3)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["trezo-card-dropdown-btn inline-block transition-all text-[26px] text-black dark:text-white leading-none hover:text-primary-500", {
                  'trezo-card-dropdown-btn inline-block transition-all text-[25px] leading-none hover:text-primary-500': true,
                  active: _ctx.isActive2,
                }]),
                id: "dropdownToggle",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive2 && _ctx.toggleActive2(...args)), ["stop"]))
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-[18px]" }, " more_vert ", -1)
              ]), 2),
              _cache[7] || (_cache[7] = _createStaticVNode("<ul class=\"trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[10000] dark:bg-dark dark:shadow-none\"><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> Mark as unread </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> Snooze </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> Add star </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> Mark as important </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> Mark as not important </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> Forward as attachment </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> Filter </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> Mute </button></li></ul>", 1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("ul", _hoisted_11, [
              _createElementVNode("li", _hoisted_12, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link relative inline-block font-medium pb-[9px] md:pb-[14px] transition-all", ['tab', { active: _ctx.activeTab === 'primary' }]]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setActiveTab('primary')))
                }, _cache[10] || (_cache[10] = [
                  _createElementVNode("span", { class: "inline-block relative ltr:pl-[27px] rtl:pr-[27px]" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-lg absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 -mt-px md:mt-0" }, " inbox "),
                    _createTextVNode(" Primary ")
                  ], -1)
                ]), 2)
              ]),
              _createElementVNode("li", _hoisted_13, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link relative inline-block font-medium pb-[9px] md:pb-[14px] transition-all", ['tab', { active: _ctx.activeTab === 'promotions' }]]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setActiveTab('promotions')))
                }, _cache[11] || (_cache[11] = [
                  _createElementVNode("span", { class: "inline-block relative ltr:pl-[27px] rtl:pr-[27px]" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-lg absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 -mt-px md:mt-0" }, " shoppingmode "),
                    _createTextVNode(" Promotions ")
                  ], -1)
                ]), 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("table", _hoisted_17, [
                    _createElementVNode("tbody", _hoisted_18, [
                      _createElementVNode("tr", null, [
                        _cache[16] || (_cache[16] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_19, [
                          _cache[12] || (_cache[12] = _createTextVNode(" Google ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_20, [
                          _cache[13] || (_cache[13] = _createTextVNode(" 2-Step Verification Turn Off ")),
                          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Integer nec arcu ac nisi...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_21, [
                          _cache[15] || (_cache[15] = _createTextVNode(" 3:36 PM ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[21] || (_cache[21] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_22, [
                          _cache[17] || (_cache[17] = _createTextVNode(" Facebook ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_23, [
                          _cache[18] || (_cache[18] = _createTextVNode(" Friend Request ")),
                          _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Sed in libero eget lorem fermentum...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_24, [
                          _cache[20] || (_cache[20] = _createTextVNode(" 9:25 AM ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[26] || (_cache[26] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_25, [
                          _cache[22] || (_cache[22] = _createTextVNode(" LinkedIn ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_26, [
                          _cache[23] || (_cache[23] = _createTextVNode(" Travel Information ")),
                          _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Vivamus vestibulum ligula in mauris...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_27, [
                          _cache[25] || (_cache[25] = _createTextVNode(" Jun 25 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[31] || (_cache[31] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_28, [
                          _cache[27] || (_cache[27] = _createTextVNode(" Ethan Parker ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_29, [
                          _cache[28] || (_cache[28] = _createTextVNode(" Leave Application ")),
                          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Integer nec arcu ac nisi...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_30, [
                          _cache[30] || (_cache[30] = _createTextVNode(" Jun 22 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[36] || (_cache[36] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_31, [
                          _cache[32] || (_cache[32] = _createTextVNode(" Dribbble ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_32, [
                          _cache[33] || (_cache[33] = _createTextVNode(" Design Inspiration ")),
                          _cache[34] || (_cache[34] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Sed in libero eget lorem fermentum...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_33, [
                          _cache[35] || (_cache[35] = _createTextVNode(" Jun 21 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[41] || (_cache[41] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_34, [
                          _cache[37] || (_cache[37] = _createTextVNode(" Instagram ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_35, [
                          _cache[38] || (_cache[38] = _createTextVNode(" Training Schedule ")),
                          _cache[39] || (_cache[39] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Vivamus vestibulum ligula in mauris...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_36, [
                          _cache[40] || (_cache[40] = _createTextVNode(" Jun 21 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[46] || (_cache[46] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_37, [
                          _cache[42] || (_cache[42] = _createTextVNode(" Isabella Cooper ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_38, [
                          _cache[43] || (_cache[43] = _createTextVNode(" Internal Auditor ")),
                          _cache[44] || (_cache[44] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Sed in libero eget lorem fermentum...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_39, [
                          _cache[45] || (_cache[45] = _createTextVNode(" Jun 19 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[51] || (_cache[51] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_40, [
                          _cache[47] || (_cache[47] = _createTextVNode(" Google ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_41, [
                          _cache[48] || (_cache[48] = _createTextVNode(" Password Changed ")),
                          _cache[49] || (_cache[49] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Integer nec arcu ac nisi...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_42, [
                          _cache[50] || (_cache[50] = _createTextVNode(" Jun 17 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[56] || (_cache[56] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_43, [
                          _cache[52] || (_cache[52] = _createTextVNode(" Olivia Rodriguez ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_44, [
                          _cache[53] || (_cache[53] = _createTextVNode(" Virtual Training ")),
                          _cache[54] || (_cache[54] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Vivamus vestibulum ligula in mauris...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_45, [
                          _cache[55] || (_cache[55] = _createTextVNode(" Jun 15 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[61] || (_cache[61] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_46, [
                          _cache[57] || (_cache[57] = _createTextVNode(" YouTube ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_47, [
                          _cache[58] || (_cache[58] = _createTextVNode(" New Subscriber ")),
                          _cache[59] || (_cache[59] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Sed in libero eget lorem fermentum...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_48, [
                          _cache[60] || (_cache[60] = _createTextVNode(" Jun 12 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[66] || (_cache[66] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_49, [
                          _cache[62] || (_cache[62] = _createTextVNode(" Google ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_50, [
                          _cache[63] || (_cache[63] = _createTextVNode(" Security Alert ")),
                          _cache[64] || (_cache[64] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Vivamus vestibulum ligula in mauris...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_51, [
                          _cache[65] || (_cache[65] = _createTextVNode(" Jun 10 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.activeTab === 'primary']
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("table", _hoisted_54, [
                    _createElementVNode("tbody", _hoisted_55, [
                      _createElementVNode("tr", null, [
                        _cache[71] || (_cache[71] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_56, [
                          _cache[67] || (_cache[67] = _createTextVNode(" Google ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_57, [
                          _cache[68] || (_cache[68] = _createTextVNode(" 2-Step Verification Turn Off ")),
                          _cache[69] || (_cache[69] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Integer nec arcu ac nisi...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_58, [
                          _cache[70] || (_cache[70] = _createTextVNode(" 3:36 PM ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[76] || (_cache[76] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_59, [
                          _cache[72] || (_cache[72] = _createTextVNode(" Facebook ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_60, [
                          _cache[73] || (_cache[73] = _createTextVNode(" Friend Request ")),
                          _cache[74] || (_cache[74] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Sed in libero eget lorem fermentum...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_61, [
                          _cache[75] || (_cache[75] = _createTextVNode(" 9:25 AM ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[81] || (_cache[81] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_62, [
                          _cache[77] || (_cache[77] = _createTextVNode(" LinkedIn ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_63, [
                          _cache[78] || (_cache[78] = _createTextVNode(" Travel Information ")),
                          _cache[79] || (_cache[79] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Vivamus vestibulum ligula in mauris...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_64, [
                          _cache[80] || (_cache[80] = _createTextVNode(" Jun 25 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[86] || (_cache[86] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_65, [
                          _cache[82] || (_cache[82] = _createTextVNode(" Ethan Parker ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_66, [
                          _cache[83] || (_cache[83] = _createTextVNode(" Leave Application ")),
                          _cache[84] || (_cache[84] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Integer nec arcu ac nisi...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_67, [
                          _cache[85] || (_cache[85] = _createTextVNode(" Jun 22 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[91] || (_cache[91] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_68, [
                          _cache[87] || (_cache[87] = _createTextVNode(" Dribbble ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_69, [
                          _cache[88] || (_cache[88] = _createTextVNode(" Design Inspiration ")),
                          _cache[89] || (_cache[89] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Sed in libero eget lorem fermentum...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_70, [
                          _cache[90] || (_cache[90] = _createTextVNode(" Jun 21 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[96] || (_cache[96] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_71, [
                          _cache[92] || (_cache[92] = _createTextVNode(" Instagram ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_72, [
                          _cache[93] || (_cache[93] = _createTextVNode(" Training Schedule ")),
                          _cache[94] || (_cache[94] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Vivamus vestibulum ligula in mauris...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_73, [
                          _cache[95] || (_cache[95] = _createTextVNode(" Jun 21 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[101] || (_cache[101] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_74, [
                          _cache[97] || (_cache[97] = _createTextVNode(" Isabella Cooper ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_75, [
                          _cache[98] || (_cache[98] = _createTextVNode(" Internal Auditor ")),
                          _cache[99] || (_cache[99] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Sed in libero eget lorem fermentum...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_76, [
                          _cache[100] || (_cache[100] = _createTextVNode(" Jun 19 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[106] || (_cache[106] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_77, [
                          _cache[102] || (_cache[102] = _createTextVNode(" Google ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_78, [
                          _cache[103] || (_cache[103] = _createTextVNode(" Password Changed ")),
                          _cache[104] || (_cache[104] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Integer nec arcu ac nisi...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_79, [
                          _cache[105] || (_cache[105] = _createTextVNode(" Jun 17 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[111] || (_cache[111] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_80, [
                          _cache[107] || (_cache[107] = _createTextVNode(" Olivia Rodriguez ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_81, [
                          _cache[108] || (_cache[108] = _createTextVNode(" Virtual Training ")),
                          _cache[109] || (_cache[109] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Vivamus vestibulum ligula in mauris...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_82, [
                          _cache[110] || (_cache[110] = _createTextVNode(" Jun 15 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[116] || (_cache[116] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_83, [
                          _cache[112] || (_cache[112] = _createTextVNode(" YouTube ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_84, [
                          _cache[113] || (_cache[113] = _createTextVNode(" New Subscriber ")),
                          _cache[114] || (_cache[114] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Sed in libero eget lorem fermentum...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_85, [
                          _cache[115] || (_cache[115] = _createTextVNode(" Jun 12 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[121] || (_cache[121] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[13px] md:py-[15.5px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ltr:ml-[15px] rtl:mr-[15px] leading-none text-lg"
                            }, [
                              _createElementVNode("i", { class: "ri-star-line" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_86, [
                          _cache[117] || (_cache[117] = _createTextVNode(" Google ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_87, [
                          _cache[118] || (_cache[118] = _createTextVNode(" Security Alert ")),
                          _cache[119] || (_cache[119] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "- Vivamus vestibulum ligula in mauris...", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_88, [
                          _cache[120] || (_cache[120] = _createTextVNode(" Jun 10 ")),
                          _createVNode(_component_RouterLink, {
                            to: "/apps/email/read",
                            class: "absolute top-0 left-0 right-0 bottom-0 z-[1]"
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.activeTab === 'promotions']
              ])
            ]),
            _cache[122] || (_cache[122] = _createStaticVNode("<div class=\"flex items-center md:absolute -top-[48px] ltr:right-0 rtl:left-0 mt-[15px] md:mt-0\"><p class=\"mb-0 text-sm\">1 – 11 of 100</p><ol class=\"ltr:ml-[10px] rtl:mr-[10px]\"><li class=\"inline-block mx-[1px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0\"><a href=\"#\" class=\"w-[31px] h-[31px] block leading-[29px] relative text-center rounded-md border border-gray-100 dark:border-[#172036] transition-all hover:bg-primary-500 hover:text-white hover:border-primary-500\"><span class=\"opacity-0\"> 0 </span><i class=\"material-symbols-outlined left-0 right-0 absolute top-1/2 -translate-y-1/2\"> chevron_left </i></a></li><li class=\"inline-block mx-[1px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0\"><a href=\"#\" class=\"w-[31px] h-[31px] block leading-[29px] relative text-center rounded-md border border-gray-100 dark:border-[#172036] transition-all hover:bg-primary-500 hover:text-white hover:border-primary-500\"><span class=\"opacity-0\"> 0 </span><i class=\"material-symbols-outlined left-0 right-0 absolute top-1/2 -translate-y-1/2\"> chevron_right </i></a></li></ol></div>", 1))
          ])
        ])
      ])
    ])
  ]))
}